import { parseYmd, getWeekTypeForDate } from '../scheduleUtils'

// ISO week number — keep server logic mirrored here for the label.
function isoWeek (date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
  const dayNum = d.getUTCDay() || 7
  d.setUTCDate(d.getUTCDate() + 4 - dayNum)
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
  return Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
}

export default function WeekABFilter ({ focusDate, weekSel, setWeekSel }) {
  if (!focusDate) return null
  const mondayThis = (() => {
    const d = parseYmd(focusDate)
    const dow = d.getDay()
    const offset = dow === 0 ? -6 : 1 - dow
    d.setDate(d.getDate() + offset)
    return d
  })()
  const mondayNext = new Date(mondayThis); mondayNext.setDate(mondayThis.getDate() + 7)

  const n1 = isoWeek(mondayThis); const w1 = getWeekTypeForDate(mondayThis)
  const n2 = isoWeek(mondayNext); const w2 = getWeekTypeForDate(mondayNext)

  const options = [
    { v: 'a',    label: `Wk ${n1} (${w1})` },
    { v: 'b',    label: `Wk ${n2} (${w2})` },
    { v: 'both', label: 'Both' }
  ]

  return (
    <div style={{
      display: 'flex', background: '#efe9da', borderRadius: 8, padding: 2, gap: 1
    }}>
      {options.map(o => {
        const on = weekSel === o.v
        return (
          <button
            key={o.v}
            onClick={() => setWeekSel(o.v)}
            style={{
              padding: '4px 10px', borderRadius: 6, border: 'none', cursor: 'pointer',
              fontSize: 12, fontWeight: 600, fontFamily: 'inherit',
              background: on ? '#fbf8f1' : 'transparent',
              color: on ? '#1c2419' : '#8a8472',
              boxShadow: on ? '0 1px 2px rgba(28,36,25,0.12)' : 'none',
              transition: 'all 0.12s'
            }}
          >
            {o.label}
          </button>
        )
      })}
    </div>
  )
}
